"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerLog = void 0;
var PlayerLogDispatcher = (function () {
    function PlayerLogDispatcher() {
        this.listeners = [];
    }
    PlayerLogDispatcher.prototype.addListener = function (level, listener) {
        this.listeners.push({
            level: level,
            listener: listener,
        });
    };
    PlayerLogDispatcher.prototype.removeListener = function (level, listener) {
        var index = this.listeners.findIndex(function (value) { return value.level === level && value.listener === listener; });
        if (index >= 0) {
            this.listeners.splice(index, 1);
        }
    };
    PlayerLogDispatcher.prototype.log = function (message) {
        this.listeners.forEach(function (registration) {
            if (registration.level >= message.level) {
                registration.listener.log(message);
            }
        });
    };
    return PlayerLogDispatcher;
}());
exports.PlayerLog = new PlayerLogDispatcher();
//# sourceMappingURL=PlayerLog.js.map